// import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useEffect, useState } from 'react'
import { Btn, LoaderPage } from '../../components'
import questions from '../../utils/questions.json'

export interface IQuestion {
	_id: string
	name: string
	questions: [
		{
			_id: string
			question: string
		}
	]
}

export default function TwoInstructions(): React.ReactElement {
	const navigate = useNavigate()

	function ret(): void {
		navigate('/introducao')
	}

	function next(): void {
		navigate('/quizz')
	}
	useEffect(() => {
		const header = document.querySelector('.menu')
		if (header) {
			header.classList.remove('header--margin-left', 'header--centralize')
		}
	})

	const [isLoading, setIsLoading] = useState(false) // CONTROLA O CARREGAMENTO
	const [isError, setIsError] = useState(false) // CONTROLE DE ERRO DA PAGINA
	const [arrQuest, setArrQuestion] = useState<IQuestion[]>([]) // CONTROLA O ESTADO DA LEITURA DA API
	async function getStepsQuestions(): Promise<void> {
		setIsError(false)
		try {
			setIsLoading(true)

			const json = questions as Array<IQuestion>
			setIsLoading(false)
			setArrQuestion(json)
		} catch (e) {
			setIsError(true)
		}
	}

	useEffect(() => {
		getStepsQuestions()
	}, [])

	function returnPage(): void {
		window.location.reload()
	}

	return (
		<div className="background-two">
			<div className="container">
				<Helmet>
					<title> Instruções </title>
					<meta name="description" content="Instruções" />
				</Helmet>

				<>
					{isError || isLoading ? (
						<LoaderPage
							error={isError}
							pasDelay={isLoading}
							retry={() => {
								returnPage()
							}}
						/>
					) : (
						<>
							<div className="timer">
								<img src="/assets/img/outhers/timer.png" alt="Tempo" title="Tempo" />
								<p> Leva 9 min </p>
							</div>
							<h1> Instruções </h1>

							<div className="sec-questions">
								<p>
									<>
										{' '}
										{arrQuest.length > 0 && arrQuest.reduce((previus, steps) => previus + steps.questions.length, 0)} perguntas em{' '}
										{arrQuest.length}
										{arrQuest.length >= 2 ? ' áreas' : ' área'} da Brandtech{' '}
									</>
								</p>

								<div className="questions">
									<p>
										<strong> 1. </strong>
										Para cada pergunta, você terá a possibilidade de variar sua resposta entre os números "1" ao "5",
										<br />
										sendo possível marcar qualquer um dos valores.
									</p>

									<p>
										<strong> 2. </strong>
										Escolha a opção "1" se você DISCORDA TOTALMENTE com a afirmativa.
									</p>

									<p>
										<strong> 3. </strong>
										Escolha a opção "5" se você CONCORDA TOTALMENTE com a afirmativa.
									</p>

									<p>
										<strong> 4. </strong>
										Marque as respostas intermediárias para as afirmativas com as quais você concorda parcialmente.
									</p>
								</div>
							</div>

							<div className="buttons">
								<Btn variant="outline" placeholder="Voltar" width="6.188rem" height="3.063rem" onClick={() => ret()} />

								<Btn placeholder="Iniciar avaliação" width="11.438rem" height="2.938rem" onClick={() => next()} />
							</div>
						</>
					)}
				</>
			</div>
		</div>
	)
}
